import { defineComponent as _defineComponent } from 'vue'
import { VCol, VRow } from 'ah-common-lib/src/common/components';
import { ErrorExclamationIcon } from 'ah-common-lib/src/icons/components';
import FormattedNumber from 'ah-common-lib/src/number/FormattedNumber.vue';
import { computed, PropType } from 'vue';
import { ClientRiskCollateralProfile } from 'ah-api-gateways';
import { formatCurrencyValue } from 'ah-common-lib/src/helpers/currency';

// FIXME BoxgridItem used in this component is expected to be setup globally
// Should become an explicit import once BoxGrid family of components is moved to ah-common-lib


export default /*#__PURE__*/_defineComponent({
  __name: 'MarginCollateralActiveMarginCall',
  props: {
  collateralProfileData: { type: Object as PropType<ClientRiskCollateralProfile>, required: true },
},
  setup(__props) {

const props = __props;



const {
  currency,
  totalMarkToMarket,
  variationMarginAmount,
  variationMarginAmountRequired,
  variationMarginExcessAmount,
  variationMarginIncrementPercentage: originalVariationMarginIncrementPercentage,
  variationMarginIncrementAmount,
  variationMarginIncrementsRequired,
  variationMarginPercentage: originalVariationMarginPercentage,
} = props.collateralProfileData;

const variationMarginPercentage = computed(() => originalVariationMarginPercentage * 100);

const variationMarginIncrementPercentage = computed(() => originalVariationMarginIncrementPercentage * 100);

const marginCallDataFirstColumn = computed(() => [
  { currency, label: 'Your MTM Position', value: totalMarkToMarket },
  { currency, label: `Your VM Limit (${variationMarginPercentage.value}%)`, value: variationMarginAmount },
  { currency, label: 'VM Limit Deficit', value: variationMarginExcessAmount },
]);

return { __sfc: true,props, currency, totalMarkToMarket, variationMarginAmount, variationMarginAmountRequired, variationMarginExcessAmount, originalVariationMarginIncrementPercentage, variationMarginIncrementAmount, variationMarginIncrementsRequired, originalVariationMarginPercentage, variationMarginPercentage, variationMarginIncrementPercentage, marginCallDataFirstColumn, VCol, VRow, ErrorExclamationIcon, FormattedNumber, formatCurrencyValue }
}

})